export const globalPromotionsManager = {
  header: {
    title: "Promotion-Manager",
    description:
      "Erstellen und verwalten Sie kontoweite Aufenthaltsaktionen. Sie stehen für alle Ihre Unterkünfte (Apartments und Hotels) zur Verfügung.",
  },

  toolbar: {
    info: "Hier erstellte Aktionen können im Tab <strong>Aktionen</strong> jeder Unterkunft aktiviert werden.",
    newPromotion: "Neue Aktion",
  },

  loading: "Aktionen werden geladen...",
  close: "Schließen",
  cancel: "Abbrechen",
  noLimit: "Kein Limit",

  status: {
    active: "Aktiv",
    paused: "Pausiert",
  },

  card: {
    stay: "Aufenthalt",
    discount: "Rabatt",
    validity: "Gültigkeit",
    edit: "Bearbeiten",
    delete: "Löschen",
  },

  nights: {
    range: "{min} – {max} Nächte",
    min: "ab {min} Nächten",
  },

  discount: {
    fixed: "{value} (fest)",
  },

  empty: {
    title: "Keine Aktionen erstellt",
    description:
      "Erstellen Sie Aktionen, um längere Aufenthalte zu fördern. Sie können sie für jede Unterkunft in den Einstellungen für Direktbuchungen aktivieren.",
    create: "Erste Aktion erstellen",
  },

  form: {
    editTitle: "Aktion bearbeiten",
    createTitle: "Neue Aktion",
    nameLabel: "Name der Aktion",
    namePlaceholder: "z. B. Rabatt ab 7 Nächten, Wochenangebot",
    minNights: "Mindestanzahl Nächte",
    maxNights: "Maximale Anzahl Nächte",
    optional: "(optional)",
    noLimitPlaceholder: "Kein Limit",
    discountType: "Rabattart",
    percentage: "Prozentsatz",
    fixedAmount: "Fester Betrag",
    discountValue: "Rabattwert",
    amountSuffix: "Betrag",
    validFrom: "Gültig ab",
    validTo: "Gültig bis",
    activateNow: "Aktion sofort aktivieren",
    propertiesLabel: "Unterkünfte, für die sie verfügbar ist",
    selectAll: "Alle auswählen",
    propertiesHelper:
      "Für die ausgewählten Unterkünfte werden Konfigurationseinträge angelegt.",
    infoBox:
      "Abzeichen, Reihenfolge und Verhalten können Sie später im Tab <strong>Aktionen</strong> jeder Unterkunft anpassen.",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    create: "Aktion erstellen",
  },

  deleteModal: {
    title: "Aktion löschen",
    warningStrong: "Diese Aktion kann nicht rückgängig gemacht werden.",
    warningBefore: "Sie sind dabei, die Aktion zu löschen",
    warningAfter: ". Sie steht dann für keine Unterkunft mehr zur Verfügung.",
    confirmLabel: "Geben Sie zur Bestätigung den genauen Namen ein:",
    confirmPlaceholder: "Namen der Aktion eingeben",
    deleting: "Wird gelöscht...",
    confirmDelete: "Endgültig löschen",
  },

  toasts: {
    loadError: "Die Aktionen konnten nicht geladen werden.",
    nameRequired: "Geben Sie einen Namen für die Aktion ein",
    minNightsWarning: "Die Mindestanzahl Nächte muss mindestens 1 betragen",
    discountValueWarning: "Der Rabattwert muss größer als 0 sein",
    selectProperty: "Wählen Sie mindestens eine Unterkunft aus",
    updated: "Aktion aktualisiert",
    created: "Aktion erfolgreich erstellt",
    saveFailed: "Speichern nicht möglich",
    saveError: "Fehler beim Speichern der Aktion",
    deleted: "Aktion gelöscht",
    deleteFailed: "Löschen nicht möglich",
    deleteError: "Fehler beim Löschen",
  },
};
